import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from 'utils/api';

class ShowFile extends Component {
  constructor(props, context) {
    super(props, context);
    this.showFile = this.showFile.bind(this);
  }

  showFile() {
    api
      .get(`${this.props.apiEndpoint}/file_attachment_mappings/${this.props.file.id}`)
      .then(response => {
        window.open(response.data.url);
      });
  }

  render() {
    return (
      <span className="fake-link" onClick={this.showFile}>
        {this.props.file.name}
      </span>
    );
  }
}

ShowFile.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  file: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
};

export default ShowFile;
